import React from "react";
import {
    Main
} from './styles'

const Gallery = () => {
    return(
        <Main>
            
        </Main>
    )
}

export default Gallery;